import {getBranding} from "@Branding";
import { Helmet, HelmetProps } from "react-helmet-async";
import React from "react";
import { prettifyName } from "@Utils";

interface IProps extends React.PropsWithChildren<HelmetProps> {
    name: string;
}

const PageHelmet: React.FC<IProps> = ({ name, children, ...otherProps }: IProps) => {
    let title = getBranding("app-title");
    if (title === null) title = "Totum";
    return (
        <Helmet {...otherProps}>
            <title>{prettifyName(name) + " - " + title}</title>
            {children}
        </Helmet>
    );
};
export default PageHelmet;